import {initContract} from '@ts-rest/core';
import {DB_SCHEMAS} from '../db/schemaExports';
import {z} from 'zod';

const c = initContract();

export const rolesContract = c.router(
  {
    create: {
      method: 'POST',
      path: '/',
      responses: {
        201: DB_SCHEMAS.selectRole,
        403: z.object({message: z.string()})
      },
      body: DB_SCHEMAS.createRole,
      summary: 'Create a role'
    },
    get: {
      method: 'GET',
      path: '/:id',
      pathParams: z.object({id: z.string()}),
      responses: {
        200: DB_SCHEMAS.selectRole,
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      },
      summary: 'Get a role'
    },
    update: {
      method: 'PUT',
      path: '/:id',
      pathParams: z.object({id: z.string()}),
      body: DB_SCHEMAS.updateRole,
      responses: {
        200: z.array(DB_SCHEMAS.selectRole),
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      },
      summary: 'Update a role'
    },
    delete: {
      method: 'DELETE',
      path: '/:id',
      pathParams: z.object({id: z.string()}),
      responses: {
        200: z.array(DB_SCHEMAS.selectRole),
        403: z.object({message: z.string()}),
        404: z.object({message: z.string()})
      },
      summary: 'Delete a role'
    },
    list: {
      method: 'GET',
      path: '/',
      responses: {
        200: z.array(DB_SCHEMAS.selectRole),
        403: z.object({message: z.string()})
      },
      summary: 'List roles'
    }
  },
  {
    pathPrefix: '/roles'
  }
);
